<template>
  <div>
    <mw-dialog  size="large_large" title="修改意见"  ref="dialog">
          <div class="mw-toolbar">
            <el-button @click="remove">删除</el-button>
            <!-- <el-button>读作者域修改</el-button> -->
            <el-button @click="add">添加</el-button>
            <el-button @click="update">修改</el-button>
            <el-button @click="setHidden">表单不显示意见</el-button>
            <el-button @click="setVisible">表单显示意见</el-button>
          </div>
          <div class="mw-toolbar__body mw-app__edit" style="">
            <div class="mw-pagination__body">
              <el-table
                stripe
                border
                height="100%"
                class='mw-table'
                :data="dataList"
                @selection-change = "handleSelectionChange"
                style="width: 100%">
                  <el-table-column
                    type="selection"
                    width="40"
                  />
                  <el-table-column
                    label="任务名称"
                    width="120"
                    prop="taskName">
                  </el-table-column>
                  <el-table-column
                    prop="content"
                    label="意见"
                  />

                  <el-table-column
                    prop="creator"
                    label="填写人"
                    width="120"
                  />
                  <el-table-column
                    prop="hidden"
                    width="100"
                    label="显示状态">
                    <template slot-scope="scope">
                      {{['显示', '隐藏', '标记删除'][scope.row.hidden]}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="createTime"
                    label="填写时间"
                    width="170"
                  />
              </el-table>
            </div>
            <div class="mw-pagination">
              <simple-pagination v-model="pagination" @input="updateTable"/>
            </div>
          </div>
    </mw-dialog>

    <mw-dialog  size="" title="添加意见" :footerButton="footerButton2" ref="dialog2">
      <div style="padding: 10px;">
        <el-form :model="editingForm" label-width="150px" :rules="editingRule" ref="editingFormRef">
          <el-form-item label="意见内容" prop="content">
            <el-input type="textarea" v-model="editingForm.content"></el-input>
          </el-form-item>
          <el-form-item label="意见内容格式" prop="contentType">
            <el-input type="" v-model="editingForm.contentType"></el-input>
          </el-form-item>
          <el-form-item label="意见类型" prop="category">
            <el-input type="" v-model="editingForm.category"></el-input>
          </el-form-item>
          <el-form-item label="办理节点" prop="task">
            <process-select  v-model="editingForm.task" :batchId="batchId"/>
          </el-form-item>
          <el-form-item label="意见填写时间" prop="createTime">
            <el-date-picker
              v-model="editingForm.createTime"
              format="yyyy-MM-dd HH:mm:ss"
              style="width:100%"
              type="datetime"
              placeholder="选择日期时间"
              align="right">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </mw-dialog>

    <mw-dialog  size="" title="修改意见" :footerButton="footerButton3" ref="dialog3">
      <div style="padding: 10px;">
        <el-form :model="editingForm2" label-width="150px" :rules="editingRule" ref="editingFormRef2">
          <el-form-item label="意见内容" prop="content">
            <el-input type="textarea" v-model="editingForm2.content"></el-input>
          </el-form-item>
          <el-form-item label="意见内容格式" prop="contentType">
            <el-input type="" v-model="editingForm2.contentType"></el-input>
          </el-form-item>
          <el-form-item label="意见类型" prop="category">
            <el-input type="" v-model="editingForm2.category"></el-input>
          </el-form-item>
          <el-form-item label="办理节点" prop="task">
            <process-select  v-model="editingForm2.task" :batchId="batchId"/>
          </el-form-item>

          <el-form-item label="不保存意见修改记录" prop="isUnSaveChange" v-show="false">
            <el-switch
              v-model="editingForm2.isUnSaveChange"
              active-color="#000"
              inactive-color="#eee">
            </el-switch>
          </el-form-item>
          <el-form-item label="意见填写时间" prop="createTime">
            <el-date-picker
              v-model="editingForm2.createTime"
              format="yyyy-MM-dd HH:mm:ss"
              style="width:100%"
              type="datetime"
              placeholder="选择日期时间"
              align="right">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="修改说明" prop="description">
            <el-input type="textarea" v-model="editingForm2.description"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </mw-dialog>
  </div>
</template>

<script>
import api from "@/common/api/maintain";
import SimplePagination from "../common/simplePagination";
import ProcessSelect from "../common/processSelect";

export default {
  data() {
    return {
      footerButton: [
        {
          label: "取消",
          func: () => {
            this.mwRef("dialog").hide();
          }
        }
      ],

      footerButton2: [
        {
          label: "取消",
          func: () => {
            this.mwRef("dialog2").hide();
          }
        },
        {
          label: "确定",
          func: async () => {
            if (await this.mwRef("editingFormRef").validate()) {
              const taskId = this.editingForm.task.id;

              const params = this.mwLodash.omit(this.editingForm, "task");
              params.creatorId=this.editingForm.task.assignee;
              params.creator=this.editingForm.task.assigneeName;
              if(_.isDate(params.createTime)){
                params.createTime =moment(params.createTime).format("YYYY-MM-DD HH:mm:ss")
              }
              if (
                (await api.addComment(taskId, params, {
                  appId: this.applicationId
                })).success
              ) {
                this.mwMsg("添加意见成功");
                this.mwRef("dialog2").hide();
                this.updateTable();
              }
            }
          }
        }
      ],

      footerButton3: [
        {
          label: "取消",
          func: () => {
            this.mwRef("dialog3").hide();
          }
        },
        {
          label: "确定",
          func: async () => {
            if (await this.mwRef("editingFormRef2").validate()) {
              const {
                isUnSaveChange,
                description,
                task: { id: taskId },
                ...params
              } = this.editingForm2;
              if(_.isDate(params.createTime)){
                params.createTime =moment(params.createTime).format("YYYY-MM-DD HH:mm:ss")
              }
              if (
                (await api.updateComment(
                  this.selection.map(x => x.id),
                  params,
                  {
                    isUnSaveChange,
                    description,
                    appId: this.applicationId
                  }
                )).success
              ) {
                this.mwMsg("修改意见成功");
                this.mwRef("dialog3").hide();
                this.updateTable();
              }
            }
          }
        }
      ],
      batchId:"",
      applicationId: "",

      pagination: {
        limit: 100,
        start: 0,
        total: 0
      },

      dataList: [],

      editingForm: {
        content: "",
        contentType: "",
        category: "",
        createTime: "",
        task: {}
      },

      editingForm2: {
        content: "",
        contentType: "",
        category: "",
        createTime: "",
        task: {}
      },

      selection: [],

      editingRule: {
        content: [
          { required: true, message: "请输入意见内容", trigger: "blur" }
        ],
        contentType: [
          { required: false, message: "请输入意见内容格式", trigger: "blur" }
        ],
        category: [
          { required: false, message: "请输入意见类型", trigger: "blur" }
        ],
        createTime: [
          { required: true, message: "请输入意见填写时间", trigger: "blur" }
        ],
        task: [
          {
            validator(rule, value, callback) {
              if (!value || !value.id) {
                callback('请选择办理节点');
              } else {
                callback();
              }
            },
            trigger: "input"
          }
        ]
      }
    };
  },

  methods: {
    async action({ applicationId, moduleId,batchId }) {
      this.mwRef("dialog").show();
      this.batchId = batchId;
      this.applicationId = applicationId;

      this.updateTable();
    },

    async updateTable() {
      const { result, success, totalCount } = await api.listCommentByBatch(
        this.batchId,
        {
          start: this.pagination.start,
          limit: this.pagination.limit
        }
      );

      this.dataList = result;
      this.pagination = { ...this.pagination, total: parseInt(totalCount, 10) };
    },

    async remove() {
      if (this.selection.length < 1) {
        this.mwMsg("warning", "请至少选择一条意见。");
        return;
      }

      if (await this.mwConfirm("确认要删除该意见吗？")) {
        if (
          (await api.deleteComment(this.selection.map(x => x.id), {
            appId: this.applicationId
          })).success
        ) {
          this.mwMsg("删除成功");
          this.updateTable();
        }
      }
    },
    async add() {
      this.editingForm.createTime = "" + new Date();
      this.mwRef("dialog2").show();
    },
    update() {
      if (this.selection.length < 1) {
        this.mwMsg("warning", "请至少选择一条意见。");
        return;
      }
      debugger;
      this.editingForm2 = {
        content: this.selection[0].content,
        contentType: this.selection[0].contentType,
        category: this.selection[0].category,
        createTime: moment(this.selection[0].createTime).toDate(),
        task: {
          id: this.selection[0].taskId,
          name: this.selection[0].taskName
        }
      };
      this.mwRef("dialog3").show();
    },

    handleSelectionChange(selection) {
      this.selection = selection;
    },

    async setHidden() {
      if (this.selection.length < 1) {
        this.mwMsg("warning", "请至少选择一条意见。");
        return;
      }

      if (await this.mwConfirm("确认要修改该意见不在表单上显示吗?")) {
        if (
          (await api.updateComment(
            this.selection.map(x => x.id),
            {
              hidden: "1"
            },
            {
              appId: this.applicationId
            }
          )).success
        ) {
          this.mwMsg("隐藏成功");
          this.updateTable();
        }
      }
    },

    async setVisible() {
      if (this.selection.length < 1) {
        this.mwMsg("warning", "请至少选择一条意见。");
        return;
      }

      if (await this.mwConfirm("确认要修改该意见在表单上显示吗?")) {
        if (
          (await api.updateComment(
            this.selection.map(x => x.id),
            {
              hidden: "0"
            },
            {
              appId: this.applicationId
            }
          )).success
        ) {
          this.mwMsg("显示成功");
          this.updateTable();
        }
      }
    }
  },

  components: {
    SimplePagination,
    ProcessSelect
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/flowInterfering/actions/changeComment.vue